// removed by extract-text-webpack-plugin
module.exports = {"Order":"Order__Order__4yi4Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/Order.css
// module id = 143
// module chunks = 0